(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ingredient-origin-map"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ingredient-map]').forEach((section) => {
    if (section.dataset.initialized === 'true') return;
    section.dataset.initialized = 'true';
    const ingredientName = section.querySelector('[data-map-ingredient]');
    const ingredientDetail = section.querySelector('[data-map-detail]');
    const ontarioPin = section.querySelector('[data-ontario-pin]');
    section.querySelectorAll('[data-ingredient-origin]').forEach((button) => {
      button.addEventListener('click', () => {
        section.querySelectorAll('[data-ingredient-origin]').forEach((item) => {
          const selected = item === button;
          item.classList.toggle('is-active', selected);
          item.setAttribute('aria-pressed', selected ? 'true' : 'false');
        });
        ingredientName.textContent = button.dataset.ingredientName;
        ingredientDetail.textContent = button.dataset.ingredientDetail;
        const showOntario = button.dataset.ingredientName === 'Egg Yolk';
        ontarioPin.classList.toggle('is-visible', showOntario);
        ontarioPin.style.opacity = showOntario ? '1' : '0';
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    const headerEl = document.querySelector('header-section[data-cart-type]');
    const cartType = headerEl ? headerEl.getAttribute('data-cart-type') : undefined;
    if (cartType !== 'page') {
      event.preventDefault();
    }
  });

  document.addEventListener('product-form:submit:success', async (event) => {
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart?sections=cart-ajax`, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      const sections = await response.json();
      const state = { sections };

      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: state,
          },
        })
      );

      document.dispatchEvent(
        new CustomEvent('cart:updated', {
          bubbles: true,
          detail: {
            cart: state,
          },
        })
      );
    } catch (e) {
      console.warn('Failed to load cart sections after add:', e);
    }
  });

  document.addEventListener('product-form:message:success', (event) => event.preventDefault());

  } catch(e) { console.error(e); }
})();
})();
